export class Application {
    id: string
    eventId: string
    volunteerRoleTypeId: string
    status: number
}

export class ApplicationViewModel {
    id: string
    userId: string
    displayName: string
    email: string
    roleName: string
    applicationDate: string
    status: number
}

export class ApplicationFilter {
    fullName: string
    email: string
    role: string
    startDate: any
    endDate: any
    eventId: string
    status: number
    lastSentEmail: number
}

export class UpdateApplicationStatus {
    applicationIds: any
    status: number
}